// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const pan: CountryValidator<"IN"> = createValidator(
  "in.pan",
  99,
);

export default pan;
export const compact = pan.compact;
export const format = pan.format;
export const validate = pan.validate;
export const generate = (): string =>
  pan.generate?.() ??
  (() => {
    throw new Error(
      "Validator in.pan cannot generate values",
    );
  })();
